// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMediaSpeakerOn_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10 15.7459C13.4505 14.8578 16 11.7256 16 7.99796C16 4.27029 13.4505 1.13809 10 0.25V2.33938C12.3304 3.16305 14 5.38553 14 7.99796C14 10.6104 12.3304 12.8329 10 13.6566V15.7459Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8 1.99792L4 4.99792H0V10.9979H4L8 13.9979V1.99792ZM2 6.99792H4L6 5.49792V10.4979L4 8.99792H2V6.99792Z" class="svg-bg"/>
  <path d="M12 7.99795C12 9.47852 11.1956 10.7712 10 11.4628V4.53308C11.1956 5.2247 12 6.51739 12 7.99795Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M16 16.1139C17.5051 15.1326 18.5 13.4342 18.5 11.5034C18.5 9.57262 17.5051 7.87422 16 6.89287V16.1139Z" class="svg-bg"/>
  <path d="M16 19.869C18.9769 18.2649 21 15.1189 21 11.5003C21 7.88171 18.9769 4.73567 16 3.13159V0.914062C20.1149 2.66545 23 6.74595 23 11.5003C23 16.2546 20.1149 20.3351 16 22.0865V19.869Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6 7.00224L13 1.50224V21.5022L6.00083 16.0029H0V7.00289L6 7.00224ZM8 15.0302V15.0289L6.69454 14.0022L2 14.0029V9.00289L6.69288 9.00224L11 5.61487V17.3873L8 15.0302Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMediaSpeakerOn is a generated icon component.
 */
let IconMediaSpeakerOn = IconMediaSpeakerOn_1 = class IconMediaSpeakerOn extends IconBaseElement {
    render() {
        return html `${IconMediaSpeakerOn_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMediaSpeakerOn.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMediaSpeakerOn = IconMediaSpeakerOn_1 = __decorate([
    customElement('zui-icon-media-speaker-on')
], IconMediaSpeakerOn);
export { IconMediaSpeakerOn };
